import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "clockAlert"
const ClockAlertIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M6.75 18.938C7.268 18.938 7.688 19.358 7.688 19.875S7.268 20.813 6.75 20.813 5.813 20.393 5.813 19.875 6.233 18.938 6.75 18.938M7.5 18.188H6V14.438H7.5z" />
          <path
            fillRule="evenodd"
            d="M6.75 11.25C10.27 11.25 13.125 14.104 13.125 17.625S10.271 24 6.75 24 .375 21.146.375 17.625 3.229 11.25 6.75 11.25M6.75 12.75C4.058 12.75 1.875 14.933 1.875 17.625S4.058 22.5 6.75 22.5 11.625 20.317 11.625 17.625 9.442 12.75 6.75 12.75"
            clipRule="evenodd"
          />
          <path d="M13.125 1.5C18.303 1.5 22.5 5.697 22.5 10.875 22.5 15.831 18.655 19.888 13.786 20.227Q14.06 19.484 14.175 18.677C18.027 18.164 21 14.868 21 10.875 21 6.525 17.474 3 13.125 3 8.979 3 5.584 6.204 5.275 10.27 4.745 10.376 4.235 10.539 3.75 10.75 3.82 5.63 7.99 1.5 13.125 1.5" />
          <path d="M12.75 4.875C13.578 4.875 14.25 5.547 14.25 6.375V10.565L15.97 12.285C16.555 12.87 16.555 13.818 15.97 14.404L12.75 11.185z" />
        </svg>
      }
    </span>
  )
}
export default ClockAlertIcon
